<style>
.sum .ivu-row .ivu-form-item {
  margin-bottom: 5px;
}
</style>
<template>
  <div class="list">
    <div class="breadcrumb">
      <Breadcrumb>
        <Breadcrumb-item href="#">CRM管理</Breadcrumb-item>
        <Breadcrumb-item>个人资源</Breadcrumb-item>
      </Breadcrumb>
    </div>
    <!--<div style="margin: 10px 0 0;">-->
    <!--<Button type="warning" @click="onPunch">我要打卡</Button>-->
    <!--<Button type="info" @click="showPunchStatistics()">今日打卡分配一览</Button>-->
    <!--</div>-->
    <div style="margin-bottom:10px">

      <Row class="margin">

          <Col :xs="8" :sm="8" :md="4">
            <Button :type="todayAllotType" :loading="todayLoading" :disable="todayLoading" icon="android-document "
                    @click="todayAllot">今日新分
            </Button>
          </Col>
          <Col :xs="8" :sm="8" :md="4">
            <Button :type="todayContactType" :loading="todayLoading" :disable="todayLoading" icon="android-document "
                    @click="todayContact">今日联系
            </Button>
          </Col>
          <Col :xs="8" :sm="8" :md="4">
            <Button :type="todayPublicType" :loading="todayLoading" :disable="todayLoading" icon="android-document "
                    @click="publicUser">公库新领
            </Button>
          </Col>
          <Col :xs="8" :sm="8" :md="4">
            <Button :type="myStudentType" icon="beer" @click="myStudent">我的学生</Button>
          </Col>
          <Col :xs="8" :sm="8" :md="4">
            <Button :type="godent" icon="beer" @click="vault">小金库</Button>
          </Col>
          <Col :xs="8" :sm="8" :md="4">
            <Button :type="payStudentType" icon="beer" @click="payStudent">常规学生</Button>
          </Col>

          <!--          <Col span="2">
                      <Button :type="typeRanking" icon="beer" @click="ranking">业绩排名</Button>
                    </Col>-->

      </Row>

      <Row class="margin">
        <Col :xs="8" :sm="8" :md="4">
          <Button type="error" icon="music-note" @click="todayLisent">今日试听</Button>
        </Col>
        <Col :xs="8" :sm="8" :md="4">
          <Button type="error" icon="ios-list-outline" @click="todayOpenClass">今日约课</Button>
        </Col>
        <Col :xs="8" :sm="8" :md="4">
          <Button :type="typeData" icon="beer" @click="myStudentAll">全部学生</Button>
        </Col>
      </Row>

      <Form :label-width="100" label-position="right">

<!--        <adviser-float-modal :adviserId="queryParam.adviserId" :teamType="queryParam.teamType"
                             @get_adviser="getAdviserInfo"></adviser-float-modal>-->


<!--        <Col span="6">
          <FormItem label="接通状态：">
            <Select v-model="queryParam.connectionStatus" clearable placeholder="请选择">
              <Option value="1">未拨打</Option>
              <Option value="2">拨打未通</Option>
              <Option value="3">拨打接通</Option>
            </Select>
          </FormItem>
        </Col>
        <Col span="6">
          <Form-item label="数据时间：">
            <Date-picker v-model="dateRange" format="yyyy-MM-dd" :clearable="false" type="daterange"
                         placement="bottom-start" placeholder="选择日期" style="width: 100%"></Date-picker>
          </Form-item>
        </Col>-->

<!--        <Col span="8">
          <FormItem label="分配时间：">
            <Col span="10">
              <Date-picker type="date" placeholder="请选择日期" format="yyyy-MM-dd"
                           @on-change="beginRegTimeChange"
                           v-model="queryParam.beginRegTime"></Date-picker>
            </Col>
            <Col span="1" style="text-align: center">-</Col>
            <Col span="10">
              <Date-picker type="date" placeholder="请选择日期" format="yyyy-MM-dd"
                           @on-change="endRegTimeChange"
                           v-model="queryParam.endRegTime"></Date-picker>
            </Col>
          </FormItem>
        </Col>-->

<!--        <Col span="8">
          <FormItem label="跟进时间：" :label-width="150">
            <Col span="10">
              <Date-picker type="date" format="yyyy-MM-dd" placeholder="请选择日期" @on-change="beginlastPhoneTime"
                           v-model="queryParam.beginlastPhoneTime"></Date-picker>
            </Col>
            <Col span="1" style="text-align: center">-</Col>
            <Col span="10">
              <Date-picker type="date" format="yyyy-MM-dd" placeholder="请选择日期" @on-change="endlastPhoneTime"
                           v-model="queryParam.endlastPhoneTime"></Date-picker>
            </Col>
          </FormItem>
        </Col>-->

        <!--          <Col span="7">
                    <FormItem label="正式开课：">
                      <Col span="11">
                        <DatePicker type="date" placeholder="请选择日期"
                                    v-model="queryParam.beginUseDate"></DatePicker>
                      </Col>
                      <Col span="2" style="text-align: center">-</Col>
                      <Col span="11">
                        <DatePicker type="date" placeholder="请选择日期" v-model="queryParam.endUseDate"></DatePicker>
                      </Col>
                    </FormItem>
                  </Col>-->

        <Row>
          <Col :xs="12" :sm="12" :md="6">
            <FormItem label="渠道：">
              <channel-select v-model="queryParam.regType"></channel-select>
<!--              <Select v-model="queryParam.regType" clearable placeholder="请选择">
                <Option v-for="item in $constant.studentCanal" :value="item.code" :key="item.code">{{ item.text }}
                </Option>
              </Select>-->
            </FormItem>
          </Col>

          <Col :xs="12" :sm="12" :md="6">
            <FormItem label="学员状态：">
              <Select v-model="queryParam.stdStatus" clearable placeholder="请选择">
                <Option value="1">新注册学生</Option>
                <Option value="3">已预约</Option>
                <Option value="4">已试听</Option>
                <Option value="5">付款未绑定</Option>
                <Option value="6">已绑定</Option>
                <Option value="7">已开课</Option>
                <Option value="8">已完课</Option>
                <Option value="9">退费</Option>
              </Select>
            </FormItem>
          </Col>

          <Col :xs="12" :sm="12" :md="12">
            <FormItem label="下次联系">
              <Col :xs="12" :sm="12" :md="6">
                <DatePicker type="date" format="yyyy-MM-dd" placeholder="请选择日期" @on-change="beginNextContactTime"
                            v-model="beginNextContact"></DatePicker>
              </Col>

              <Col :xs="12" :sm="12" :md="6">
                <DatePicker type="date" format="yyyy-MM-dd" placeholder="请选择日期" @on-change="endNextContactTime"
                            v-model="endNextContact"></DatePicker>
              </Col>
            </FormItem>
          </Col>

          <Col :xs="12" :sm="12" :md="6">
            <Form-item label="学生:" :label-width="70">
              <Input placeholder="ID/手机号/姓名" name="searchKeyword"
                     v-model="queryParam.searchKeyword"></Input>
            </Form-item>
          </Col>

          <Col :xs="12" :sm="12" :md="6">
            <FormItem label="意向等级：">
              <Select v-model="queryParam.intentLevel" clearable placeholder="请选择">
                <Option value="1">高意向</Option>
                <Option value="2">意向一般</Option>
                <Option value="3">待跟进</Option>
                <Option value="4">无效资源</Option>
              </Select>
            </FormItem>
          </Col>

          <Col :xs="12" :sm="12" :md="6">
            <FormItem label="渠道来源：">
              <Select v-model="queryParam.tchChannel" clearable placeholder="请选择">
                <Option v-for="item in $constant.tchChannel"
                        :value="item.code" :key="item.code">{{ item.text }}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col :xs="12" :sm="12" :md="6">
            <Form-item :label-width="60" label="渠道分类">
              <Select v-model="queryParam.channelType" clearable>
                <Option v-for="item in this.$constant.channelTypeEnum" :value="item.id" :key="item.id">{{ item.text }}</Option>
              </Select>
            </Form-item>
          </Col>
          <Col :xs="18" :sm="18" :md="20">
            <adviser-float-modal :adviserId="queryParam.adviserId" :teamType="queryParam.teamType"
                                 @get_adviser="getAdviserInfo"></adviser-float-modal>
          </Col>
        </Row>

      </Form>

      <div class="button-container">

        <Button class="left-button" type="primary" :loading="searchLoading" :disable="searchLoading" icon="search"
                @click="search">搜索
        </Button>

        <div class="spacer"></div>

        <Row>
          <Button type="primary" icon="move-round" @click="onBatchMoveUser">批量移至公库</Button>
          <Button type="primary" icon="plus-round" @click="onInsertUser" class-name="">添加学生</Button>
          <Button type="primary" icon="person-add" @click="onAssignAdviser"
                  v-if="myStudentType === 'success'">批量分配课程顾问</Button>
        </Row>

      </div>

    </div>
    <!--<div style="margin-bottom:10px;font-size: small" class="sum">
      <Form :label-width="80" label-position="left">
        <Row>
          &lt;!&ndash;<Col span="3" > <Form-item :label-width="120" label="本月指标统计："></Form-item></Col>&ndash;&gt;
          <Col span="3" > <Form-item label="目标："> {{orderQuantity}}</Form-item></Col>
          <Col span="3"> <Form-item label="完成量："> {{finishOrderQuantity}}</Form-item></Col>
          <Col span="3"> <Form-item label="成交金额："> {{dealMoney}}</Form-item></Col>
          <Col span="3"> <Form-item label="完成率："> {{dealRate}}</Form-item></Col>
        </Row>
      </Form>
    </div>-->
    <List :height="680" ref="dataList" :tableColumns="title" :reload="reload" :listUrl="listUrl"
          :pageSize="num" show-sizer :page-size-opts="[10, 20, 50, 100]" :params="queryParam" :onLoading="onLoading"
          @on-selection-change="selectionChange" @on-sort-change="handleSortChange"></List>
    <UserInfoModal :value="editUser" @on-close="closeModal" :uid="uid" :successCallback="search"></UserInfoModal>
    <today-punch-statistics-modal :value="showTodayPunchStatisticsModal" @on-close="showTodayPunchStatisticsModal=false"
                                  :successCallback="search"></today-punch-statistics-modal>
    <UserLeaveModal v-model="showUserLeaveModal" :uid="uid" @on-close="closeModal"
                    :successCallback="search"></UserLeaveModal>
    <UserTempLessonModal :user="tempLessonUser" v-model="showUserTempLessonModal"></UserTempLessonModal>
    <UserPLLessonModal :user="pLLessonUser" v-model="showUserPLLessonModel"></UserPLLessonModal>
    <UserChineseLessonModal :user="chineseLessonUser" v-model="showUserChineseLessonModal"></UserChineseLessonModal>

    <UserClassHourModal :uid="uid" v-model="showUserClassHourModal"></UserClassHourModal>
    <UserLeaveNumModal :uid="uid" v-model="showUserLeaveNumModal"></UserLeaveNumModal>
    <UserLessonNumModal :uid="uid" v-model="showUserLessonNumModal"></UserLessonNumModal>
    <CourseSchedulingModal :uid="uid" v-model="showCourseSchedulingModal"></CourseSchedulingModal>
    <BindTchModal :user="currentRow" :successCallback="search" v-model="showBindTchModal"
                  :isBinded="isBinded"></BindTchModal>
    <UserInfoModal :value="editUser" :tabValue="tabValue" @on-close="closeModal" :uid="uid"
                   :successCallback="search"></UserInfoModal>
    <InsertUserModal :successCallback="search" v-model="showInsertUserModal"></InsertUserModal>
    <UserTrialLessonModal :user="trialaLessonUser" v-model="showUserTrialLessonModal"></UserTrialLessonModal>
    <add-order-modal :value="addOrderModal" @on-close="addOrderModal=false" :successCallback="search"></add-order-modal>
    <BatchMoveUserModal :successCallback="search" :userList="selectionUser"
                        v-model="showBatchMoveUser"></BatchMoveUserModal>
    <AssignAdviserModal :successCallback="reloadAfterAssign" :userList="selectionUser"
                        v-model="showAssignAdviserModal"></AssignAdviserModal>
  </div>
</template>

<script>
import StudentInfo from '../common/StudentInfo.vue'
import AdviserFloatModal from '../common/AdviserFloatModal.vue'
import UserInfoModal from './UserInfoModal.vue'
import TodayPunchStatisticsModal from './TodayPunchStatisticsModal.vue'
import UserLeaveModal from '../user/UserLeaveModal.vue'
import UserTempLessonModal from '../user/modal/UserTempLessonModal.vue'
import UserPLLessonModal from '../user/UserPLLessonModal.vue'
import UserChineseLessonModal from '../user/UserChineseLessonModal.vue'
import UserClassHourModal from '../user/UserClassHourModal.vue'
import UserLeaveNumModal from '../user/UserLeaveNumModal.vue'
import UserLessonNumModal from '../user/UserLessonNumModal.vue'
import CourseSchedulingModal from '../user/modal/CourseSchedulingModal.vue'
import BindTchModal from '../user/modal/BindTchModal.vue'
import AddOrderModal from '../order/AddOrderModal.vue'
import UserTrialLessonModal from '../user/UserTrialLessonModal.vue'
import dateFormat from '@/tools/date/format.js'
import dates from '@/tools/date/dates.js'
import InsertUserModal from '../user/modal/InsertUserModal'
import AssignAdviserModal from '../user/AssignAdviserModal.vue'
import BatchMoveUserModal from '../user/BatchMoveUserModal.vue'

export default {
  components: {
    BatchMoveUserModal,
    AssignAdviserModal,
    StudentInfo,
    AdviserFloatModal,
    UserInfoModal,
    TodayPunchStatisticsModal,
    UserLeaveModal,
    UserTempLessonModal,
    UserPLLessonModal,
    UserChineseLessonModal,
    UserClassHourModal,
    UserLeaveNumModal,
    CourseSchedulingModal,
    BindTchModal,
    UserLessonNumModal,
    AddOrderModal,
    UserTrialLessonModal,
    InsertUserModal
  },
  data () {
    let $constant = this.$constant
    let $moment = this.$moment
    return {
      num: 10,
      dateRange: [],
      showTodayPunchStatisticsModal: false,
      payStudentType: 'error',
      myStudentType: 'error',
      godent: 'error',
      typeData: 'error',
      typeRanking: 'error',
      todayContactType: 'error',
      todayPublicType: 'error',
      todayAllotType: 'success',
      showPassModal: false,
      loadingPass: false,
      editUser: false,
      searchLoading: false,
      todayLoading: false,
      vaultLoading: false,
      exportLoading: false,
      tabValue: 0,
      showTestNetworkModal: false,
      showUserLeaveModal: false,
      tempLessonUser: {},
      showUserTempLessonModal: false,
      pLLessonUser: {},
      showUserPLLessonModel: false,
      chineseLessonUser: {},
      showUserChineseLessonModal: false,
      showUserClassHourModal: false,
      showUserLeaveNumModal: false,
      showUserLessonNumModal: false,
      showCourseSchedulingModal: false,
      showBindTchModal: false,
      isBinded: false,
      currentRow: null,
      showUserTrialLessonModal: false,
      trialaLessonUser: {},
      addOrderModal: false,
      orderQuantity: 0,
      finishOrderQuantity: 0,
      beginNextContact: '',
      endNextContact: '',
      dealMoney: 0.0,
      dealRate: '0%',
      reload: 0,
      listUrl: '/userList/todayAllot',
      uid: null,
      showInsertUserModal: false,
      showBatchMoveUser: false,
      showAssignAdviserModal: false,
      loadingInsertUser: false,
      queryParam: {
        tchChannel: '',
        channelType: '',
        intentLevel: '',
        stdStatus: '',
        connectionStatus: '',
        stdTab: -1,
        searchKeyword: '',
        beginRegTime: '',
        endRegTime: '',
        beginUseDate: '',
        endUseDate: '',
        beginlastPhoneTime: '',
        endlastPhoneTime: '',
        beginNextContactTime: '',
        endNextContactTime: '',
        adviserId: null,
        adviserIds: [],
        teamType: null,
        type: 1,
        regType: '',
        isPay: '-1',
        newPublic: '',
        isPrivate: '',
        startTime: '',
        endTime: '',
      },
      selectionUser: [],
      resourceTitle: [
        {
          type: 'selection',
          width: 60,
          fixed: 'left',
          align: 'center'
        },
        {
          title: 'ID/姓名',
          width: 150,
          fixed: 'left',
          align: 'center',
          render: (h, params) => {
            let row = params.row
            return h('a', {on: {click: () => this.openInfoModal(row.id)}}, row.id + '-' + row.nickname)
          }
        },
        {
          title: '手机号',
          width: 150,
          align: 'center',
          render: (h, params) => {
            if (params.row.mobile.startsWith('n')) {
              return h('span', '')
            }
            return h('Poptip', {
              props: {
                trigger: 'hover'
              }
            }, [
              h('span', {}, params.row.mobile.length === 11 ? params.row.mobile.substring(0, 3) +
                '****' + params.row.mobile.substring(7) : params.row.mobile),
              // 当前行展示的数据
              h('div', {slot: 'content'}, params.row.mobile)
            ])
          }
        },
        {
          title: '打电话',
          width: 100,
          render: (h, params) => {
            let row = params.row
            return h('div', [
              h('button', {attrs: {class: 'telephone2'}, on: {click: () => this.dialTel(row.uid, row.mobile)}})
            ])
          }
        },
        {
          title: '微信',
          width: 100,
          key: 'webChat'
        },
        /*   {
           title: '资源状态',
//            width: 120,
           render: (h, params) => {
             let resourceStatus = params.row.resourceStatus
             let resourceStatuslEnum = $constant.getEnum($constant.resourceStatus, resourceStatus)
             return h('div', resourceStatuslEnum && resourceStatuslEnum.text)
           }
         },  */
        // {
        //   title: '接通状态',
        //   width: 120,
        //   render: (h, params) => {
        //     let connectionStatus = params.row.connectionStatus
        //     let connectionStatuslEnum = $constant.getEnum($constant.connectionStatus, connectionStatus)
        //     return h('div', connectionStatuslEnum && connectionStatuslEnum.text)
        //   }
        // },
        // {
        //   title: '客户意向',
        //   width: 120,
        //   render: (h, params) => {
        //     let intentLevel = params.row.intentLevel
        //     let intentLevelEnum = $constant.getEnum($constant.intentLevel, intentLevel)
        //     return h('div', intentLevelEnum && intentLevelEnum.text)
        //   }
        // },
        {
          title: '名单标签',
          width: 120,
          align: 'center',
          render: (h, params) => {
            let assignNum = params.row.assignNum
            let assignNumEnum = $constant.getEnum($constant.assignNumEnum, assignNum)
            return h('div', assignNumEnum && assignNumEnum.text)
          }
        },
        {
          title: '跟进内容',
          width: 300,
          align: 'center',
          render: (h, params) => {
            let self = this
            let row = params.row
            return h('div', [
              h('span', row.followUpContent),
              h('br'),
              h('a', {on: {click: () => self.edit(row.uid)}}, '跟进内容')
            ])
          }
        },
        {
          title: '下次联系',
          width: 120,
          align: 'center',
          key: 'nextContactTime',
          sortable: 'custom'
        },
        {
          title: '渠道',
          width: 120,
          align: 'center',
          key: 'regType'
          // render: (h, params) => {
          //   let regType = params.row.regType
          //   let regTypeEnum = $constant.getEnum($constant.studentCanal, regType)
          //   return h('div', regTypeEnum && regTypeEnum.text)
          // }
        },
        {
          title: '推荐人',
          width: 120,
          align: 'center',
          render: (h, params) => {
            let auName = params.row.auName
            let auId = params.row.auId
            if (auName && auId) {
              return h('span', auId + '-' + auName)
            }
            return h('span', '')
          }
        },
        {
          title: '注册时间',
          width: 115,
          align: 'center',
          key: 'registerTime',
          sortable: 'custom'
        },
        {
          title: '学员状态',
          width: 120,
          align: 'center',
          render: (h, params) => {
            let stdStatus = params.row.stdStatus
            let stdStatuslEnum = $constant.getEnum($constant.stdStatus, stdStatus)
            return h('div', {style: {'font-size': '12px'}}, [h('p', stdStatuslEnum && stdStatuslEnum.text), h('p', params.row.lessonTitle), h('p', params.row.demoTchName)])
          }
        },
        /* {
          title: '学习导师',
//            width: 120,
          key: 'auNickname'
        }, */
        {
          title: '最后编辑信息',
          width: 150,
          align: 'center',
          key: 'nameAndModified'
        },
        {
          title: '操作',
          align: 'center',
          fixed: 'right',
          width: 120,
          render: (h, params) => {
            // let row = params.row
            let btn = []
            btn.push(h('Dropdown-item', {props: {name: 'trialLesson'}}, '约试听课'))
            btn.push(h('Dropdown-item', {props: {name: 'addOrder'}}, '添加订单'))
            btn.push(h('Dropdown-item', {props: {name: 'moveUser'}}, '移至公库'))
            btn.push(h('Dropdown-item', {props: {name: 'moveGodent'}}, '移至小金库'))
            return h('div', [
              h('span', {class: 'divider'}),
              h('Dropdown', {
                props: {
                  transfer: true,
                  trigger: 'click',
                },
                on: {
                  'on-click': (name) => {
                    let row = params.row
                    if (name === 'trialLesson') {
                      this.onTrialLesson(row)
                    } else if (name === 'addOrder') {
                      this.addOrderModal = true
                    } else if (name === 'moveUser') {
                      this.onPass(params.row)
                    } else if (name === 'moveGodent') {
                      this.onMoveGent(params.row)
                    }
                  }
                }
              }, [
                h('a', [
                  h('span', '更多 '),
                  h('Icon', {props: {type: 'ios-arrow-down'}})
                ]),
                h('Dropdown-menu', {slot: 'list'}, btn)
              ])
            ])
          }
          /*  render: (h, params) => {
             let self = this
             let row = params.row
             return h('div', [
               h('a', {on: {click: () => self.edit(row.uid)}}, '编辑'),
               h('span', ' | '),
               h('a', {
                 on: {
                   click: () => {
                     this.onPass(params.row)
                   }
                 }
               }, '移至公库')
             ])
           } */
        }
      ],
      rankingTtile: [
        {
          type: 'index',
          title: '排名',
          width: 100,
        },
        {
          title: '课顾',
          width: 150,
          key: 'adviserName',
          render: (h, params) => {
            let row = params.row
            if (row.state === 1) {
              return h('span', [
                h('span', row.adviserName)
              ])
            } else {
              return h('span', [
                h('span', row.adviserName),
                h('span', {style: {color: 'red'}}, '(离职)')
              ])
            }
          }
        },
        {
          title: '目标(单)',
          width: 100,
          render: (h, params) => {
            let row = params.row
            return h('span', row.orderQuantity)
          }
        },
        {
          title: '完成量(单)',
          width: 110,
          render: (h, params) => {
            let row = params.row
            return h('span', row.finishOrderQuantity)
          }
        },
        {
          title: '成交金额',
          width: 100,
          render: (h, params) => {
            let row = params.row
            return h('span', row.dealMoney)
          }
        },
        {
          title: '完成率',
          width: 100,
          render: (h, params) => {
            let row = params.row
            return h('span', row.finishRate.toFixed(2) + '%')
          }
        }
      ],
      privateTitle: [
        {
          title: 'ID/姓名',
          width: 120,
          render: (h, params) => {
            let row = params.row
            return h('a', {on: {click: () => this.openInfoModal(row.id)}}, row.id + '-' + row.nickname)
          }
        },
        {
          title: '手机号',
          width: 150,
          render: (h, params) => {
            if (params.row.mobile.startsWith('n')) {
              return h('span', '')
            }
            let row = params.row
            return h('div', [
              h('span', row.mobile),
              h('br'),
              h('button', {attrs: {class: 'telephone2'}, on: {click: () => this.dialTel(row.id, row.mobile)}})
            ])
          }
        },
        {
          title: '城市',
          width: 100,
          key: 'city'
        },
        {
          title: '微信',
          width: 100,
          key: 'webChat'
        },
        /*   {
           title: '资源状态',
//            width: 120,
           render: (h, params) => {
             let resourceStatus = params.row.resourceStatus
             let resourceStatuslEnum = $constant.getEnum($constant.resourceStatus, resourceStatus)
             return h('div', resourceStatuslEnum && resourceStatuslEnum.text)
           }
         },  */
        {
          title: '接通状态',
          width: 120,
          render: (h, params) => {
            let connectionStatus = params.row.connectionStatus
            let connectionStatuslEnum = $constant.getEnum($constant.connectionStatus, connectionStatus)
            return h('div', connectionStatuslEnum && connectionStatuslEnum.text)
          }
        },
        {
          title: '客户意向',
          width: 120,
          render: (h, params) => {
            let intentLevel = params.row.intentLevel
            let intentLevellEnum = $constant.getEnum($constant.intentLevel, intentLevel)
            return h('div', intentLevellEnum && intentLevellEnum.text)
          }
        },
        {
          title: '名单标签',
          width: 120,
          render: (h, params) => {
            let assignNum = params.row.assignNum
            let assignNumEnum = $constant.getEnum($constant.assignNumEnum, assignNum)
            return h('div', assignNumEnum && assignNumEnum.text)
          }
        },
        {
          title: '跟进内容',
          width: 200,
          render: (h, params) => {
            let self = this
            let row = params.row
            return h('div', [
              h('Poptip', {
                props: {
                  trigger: 'hover',
                  placement: 'top'
                }
              }, [
                h('span', {
                  style: {
                    display: 'inline-block',
                    width: '100%',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap'
                  }
                }, row.followUpContent),
                h('div', { slot: 'content' }, row.followUpContent)
              ]),
              h('br'),
              h('a', { on: { click: () => self.edit(row.uid) } }, '跟进内容')
            ])
          }
        },
        {
          title: '下次联系',
          width: 120,
          key: 'nextContactTime'
        },
        {
          title: '渠道',
          width: 120,
          key: 'regType'
          // render: (h, params) => {
          //   let regType = params.row.regType
          //   let regTypeEnum = $constant.getEnum($constant.studentCanal, regType)
          //   return h('div', regTypeEnum && regTypeEnum.text)
          // }
        },
        {
          title: '推荐人',
          width: 120,
          render: (h, params) => {
            let auName = params.row.auName
            let auId = params.row.auId
            if (auName && auId) {
              return h('span', auId + '-' + auName)
            }
            return h('span', '')
          }
        },
        {
          title: '注册时间',
          width: 170,
          key: 'registerTime'
        },
        {
          title: '学员状态',
          width: 120,
          render: (h, params) => {
            let stdStatus = params.row.stdStatus
            let stdStatuslEnum = $constant.getEnum($constant.stdStatus, stdStatus)
            return h('div', {style: {'font-size': '12px'}}, [h('p', stdStatuslEnum && stdStatuslEnum.text), h('p', params.row.lessonTitle), h('p', params.row.demoTchName)])
          }
        },
        /* {
          title: '学习导师',
//            width: 120,
          key: 'auNickname'
        }, */
        {
          title: '最后编辑信息',
          width: 150,
          key: 'nameAndModified'
        },
        {
          title: '操作',
          align: 'center',
          width: 120,
          render: (h, params) => {
            // let row = params.row
            let btn = []
            btn.push(h('Dropdown-item', {props: {name: 'trialLesson'}}, '约试听课'))
            btn.push(h('Dropdown-item', {props: {name: 'addOrder'}}, '添加订单'))
            btn.push(h('Dropdown-item', {props: {name: 'moveGodent'}}, '移出小金库'))
            return h('div', [
              h('span', {class: 'divider'}),
              h('Dropdown', {
                props: {
                  transfer: true,
                  trigger: 'click',
                },
                on: {
                  'on-click': (name) => {
                    let row = params.row
                    if (name === 'trialLesson') {
                      this.onTrialLesson(row)
                    } else if (name === 'addOrder') {
                      this.addOrderModal = true
                    } else if (name === 'moveUser') {
                      this.onPass(params.row)
                    } else if (name === 'moveGodent') {
                      this.onRemoveGent(params.row)
                    }
                  }
                }
              }, [
                h('a', [
                  h('span', '更多 '),
                  h('Icon', {props: {type: 'ios-arrow-down'}})
                ]),
                h('Dropdown-menu', {slot: 'list'}, btn)
              ])
            ])
          }
          /*  render: (h, params) => {
             let self = this
             let row = params.row
             return h('div', [
               h('a', {on: {click: () => self.edit(row.uid)}}, '编辑'),
               h('span', ' | '),
               h('a', {
                 on: {
                   click: () => {
                     this.onPass(params.row)
                   }
                 }
               }, '移至公库')
             ])
           } */
        }
      ],
      userPaytitle: [
        {
          title: '学生ID/姓名',
          width: 100,
          render: (h, params) => {
            let row = params.row
            return h('a', {on: {click: () => this.openInfoModal(row.id)}}, row.id + '-' + row.nickname)
          }
        },
        {
          title: '手机号',
          width: 150,
          align: 'center',
          render: (h, params) => {
            if (params.row.mobile.startsWith('n')) {
              return h('span', '')
            }
            let row = params.row
            return h('div', [
              h('span', row.mobile),
              h('br'),
              h('button', {attrs: {class: 'telephone2'}, on: {click: () => this.dialTel(row.id, row.mobile)}})
            ])
          }
        },
        {
          title: '课程顾问',
          width: 90,
          key: 'adviserName',
          render: (h, params) => {
            return h('span', params.row.adviserName || '未分配')
          }
        },
        {
          title: '学导',
          width: 100,
          key: 'studyAdviserName',
          render: (h, params) => {
            return h('span', params.row.studyAdviserName || '未分配')
          }
        },
        {
          title: '绑定老师',
          width: 150,
          render: (h, params) => {
            let row = params.row
            if (row.tchBoundNum === 0) {
              return h('span', '未绑定')
            }
            if (!row.tchIdAndNames) {
              console.log('row:' + JSON.stringify(row))
              return h('span', '')
            }
            let tchIdAndNameArr = row.tchIdAndNames.split(',')
            let spans = []
            for (let i = 0; i < tchIdAndNameArr.length; i++) {
              let obj = h('span', tchIdAndNameArr[i])
              spans.push(obj)
              spans.push(h('br'))
            }
            return h('div', spans)
          }
        },
        {
          title: '等级',
          width: 80,
          render: (h, params) => {
            return h('span', params.row.levelTitle || '未分级')
          }
        },
        {
          title: '上课时间',
          width: 160,
          render: (h, params) => {
            let list = params.row.bookWorkLessonOpenedTimeList
            if (!list) {
              return h('span', '未绑定')
            }
            let spanArr = []
            list.forEach(function (element) {
              let startTime = $moment.unix(element.startTime).utc().format(' HH:mm')
              spanArr.push(h('span',
                $constant.weekZh[element.week] + startTime))
              spanArr.push(h('br'))
            })
            return h('div', spanArr)
          }
        },
        {
          title: '总课时(外教/中教)',
          width: 100,
          render: (h, params) => {
            let row = params.row
            return h('span', row.routineNum + ' / ' + row.chineseNum)
          }
        },
        {
          title: '剩余(外教/中教)',
          width: 130,
          render: (h, params) => {
            let row = params.row
            return h('span',
              (row.routineNum - row.routineEndNum) + ' / ' + (row.chineseNum - row.chineseEndNum))
          }
        },
        {
          title: '赠送课时',
          width: 80,
          align: 'center',
          key: 'discountNum'
        },
        {
          title: '请假/补课次数',
          width: 100,
          render: (h, params) => {
            let row = params.row
            return h('span',
              (row.leaveNum) + ' / ' + (row.makeupLessonNum - row.makeupLessonEndNum))
          }
        },
        {
          title: '微信',
          width: 80,
          align: 'center',
          key: 'webChat'
        },
        {
          title: '操作',
          align: 'center',
//            fixed: 'right',
          width: 100,
          render: (h, params) => {
            let row = params.row
            let id = row.id
            let btn = []
            btn.push(h('Dropdown-item', {props: {name: 'userTemp'}}, '临时约课'))

            let bookWorkLessonOpenedTimeList = row.bookWorkLessonOpenedTimeList
            if (!bookWorkLessonOpenedTimeList) {
              btn.push(h('Dropdown-item', {props: {name: 'bindTch'}}, '绑定老师'))
            } else {
              btn.push(h('Dropdown-item', {props: {name: 'editBindTch'}}, '修改绑定'))
              // btn.push(h('Dropdown-item', { props: { name: 'unbindTch' } }, '解绑老师'))
            }
            btn.push(h('Dropdown-item', {props: {name: 'changeDirector'}}, '学员转移'))
            btn.push(h('Dropdown-item', {props: {name: 'classHour'}}, '加减课时'))
            btn.push(h('Dropdown-item', {props: {name: 'leaveNum'}}, '加减请假次数'))
            btn.push(h('Dropdown-item', {props: {name: 'lessonNum'}}, '加减补课次数'))

            return h('div', [
              h('Dropdown', {
                props: {
                  transfer: true,
                  trigger: 'click',
                },
                on: {
                  'on-click': (name) => {
                    if (name === 'userTemp') {
                      this.showUserTempLessonModal = true
                      this.tempLessonUser = row
                    } else if (name === 'bindTch') {
                      this.currentRow = row
                      this.showBindTchModal = true
                      this.isBinded = false
                    } else if (name === 'editBindTch') {
                      this.currentRow = row
                      this.showBindTchModal = true
                      this.isBinded = true
                    } else if (name === 'unbindTch') {
                      this.onUnbingTch(row)
                    } else if (name === 'classHour') {
                      this.uid = id
                      this.showUserClassHourModal = true
                    } else if (name === 'changeDirector') {
                      this.uid = id
                      this.onChangeDirector(row)
                    } else if (name === 'leaveNum') {
                      this.uid = id
                      this.showUserLeaveNumModal = true
                    } else if (name === 'lessonNum') {
                      this.uid = id
                      this.showUserLessonNumModal = true
                    }
                  }
                }
              }, [
                h('a', [
                  h('span', '更多 '),
                  h('Icon', {props: {type: 'ios-arrow-down'}})
                ]),
                h('Dropdown-menu', {slot: 'list'}, btn)
              ]),
            ])
          }
        }
      ],
      dataTitle: [
        // {
        //   title: 'ID',
        //   width: 100,
        //   key: 'adviserId',
        // },
        {
          title: '课顾',
          width: 150,
          key: 'adviserName',
          render: (h, params) => {
            let row = params.row
            if (row.state === 1) {
              return h('span', [
                h('span', row.adviserName)
              ])
            } else {
              return h('span', [
                h('span', row.adviserName),
                h('span', {style: {color: 'red'}}, '(离职)')
              ])
            }
          }
        },
        {
          title: '外呼次数',
          width: 100,
          render: (h, params) => {
            let row = params.row
            return h('span', row.outerCallNum)
          }
        },
        /*          {
                    title: '外呼量',
                    width: 100,
                    render: (h, params) => {
                      let row = params.row
                      return h('span', row.outerCallTime.toFixed(2))
                    }
                  },
                  */
        {
          title: '接听量',
          width: 100,
          render: (h, params) => {
            let row = params.row
            return h('span', row.answerTime.toFixed(2))
          }
        },
        {
          title: '通时',
          width: 100,
          render: (h, params) => {
            let row = params.row
            return h('span', row.callTime.toFixed(2))
          }
        },
        {
          title: '名单数',
          width: 100,
          render: (h, params) => {
            let row = params.row
//              return h('a', {on: {click: () => this.showAssignDetail(row.adviserId)}}, row.totalListNum)
            return h('span', row.totalListNum)
          }
        },
        {
          title: '邀约数',
          width: 100,
          key: 'inviteListNum',
          render: (h, params) => {
            let row = params.row
//              return h('a', {on: {click: () => this.showDetails(row.adviserId, 1)}}, row.inviteListNum)
            return h('span', row.inviteListNum)
          }
        },
        {
          title: '邀约率',
          width: 100,
          render: (h, params) => {
            let row = params.row
            return h('span', row.inviteRate.toFixed(2) + '%')
          }
        },
        {
          title: '出席数',
          key: 'attendNum',
          width: 100,
          render: (h, params) => {
            let row = params.row
//              return h('a', {on: {click: () => this.showDetails(row.adviserId, 2)}}, row.attendNum)
            return h('span', row.attendNum)
          }
        },
        {
          title: '出席率',
          width: 100,
          render: (h, params) => {
            let row = params.row
            return h('span', row.attendRate.toFixed(2) + '%')
          }
        },
        {
          title: '成交数',
          key: 'dealNum',
          width: 100,
          render: (h, params) => {
            let row = params.row
//              return h('a', {on: {click: () => this.showDetails(row.adviserId, 3)}}, row.dealNum)
            return h('span', row.dealNum)
          }
        },
        /*          {
                    title: '总成交率',
                    width: 100,
                    render: (h, params) => {
                      let row = params.row
                      return h('span', row.dealRate.toFixed(2) + '%')
                    }
                  },
                  */
        {
          title: '注册成交率',
          width: 110,
          render: (h, params) => {
            let row = params.row
            return h('span', row.payUserRate.toFixed(2) + '%')
          }
        },
        {
          title: '出席成交率',
          width: 110,
          render: (h, params) => {
            let row = params.row
            return h('span', row.attendDealRate.toFixed(2) + '%')
          }
        },
        {
          title: '目标(单)',
          width: 100,
          render: (h, params) => {
            let row = params.row
            return h('span', row.orderQuantity)
          }
        },
        {
          title: '完成量(单)',
          width: 110,
          render: (h, params) => {
            let row = params.row
            return h('span', row.finishOrderQuantity)
          }
        },
        {
          title: '成交金额',
          width: 100,
          render: (h, params) => {
            let row = params.row
            return h('span', row.dealMoney)
          }
        },
        {
          title: '完成率',
          width: 100,
          render: (h, params) => {
            let row = params.row
            return h('span', row.finishRate.toFixed(2) + '%')
          }
        },
      ],
      title: [],
    }
  },
  methods: {
    // 约试听
    onTrialLesson (row) {
      this.showUserTrialLessonModal = true
      this.trialaLessonUser = row
    },
    publicUser () {
      this.typeRanking = 'error'
      this.typeData = 'error'
      this.payStudentType = 'error'
      this.todayAllotType = 'error'
      this.todayPublicType = 'success'
      this.todayContactType = 'error'
      this.myStudentType = 'error'
      this.godent = 'error'
      this.queryParam.type = 1
      // this.queryParam.todayContact = ''
      this.queryParam.newPublic = 2
      this.title = this.resourceTitle
      delete this.queryParam.sortProperty
      delete this.queryParam.sortDirection
      if (this.listUrl === '/userList/todayAllot') {
        this.reload = new Date().getTime()
      } else {
        this.listUrl = '/userList/todayAllot'
      }
    },
    todayContact () {
      this.typeRanking = 'error'
      this.typeData = 'error'
      this.payStudentType = 'error'
      this.todayAllotType = 'error'
      this.todayPublicType = 'error'
      this.todayContactType = 'success'
      this.myStudentType = 'error'
      this.godent = 'error'
      this.queryParam.type = -1
      // this.queryParam.todayContact = 1
      this.queryParam.newPublic = ''
      this.title = this.resourceTitle
      if (this.listUrl === '/userList/todayContact') {
        this.reload = new Date().getTime()
      } else {
        this.listUrl = '/userList/todayContact'
      }
    },
    payStudent () {
      this.typeRanking = 'error'
      this.typeData = 'error'
      this.todayPublicType = 'error'
      this.payStudentType = 'success'
      this.todayAllotType = 'error'
      this.todayContactType = 'error'
      this.myStudentType = 'error'
      this.godent = 'error'
      this.title = this.userPaytitle
      if (this.listUrl === '/userList/payList') {
        this.reload = new Date().getTime()
      } else {
        this.listUrl = '/userList/payList'
      }
    },
    ranking () {
      this.payStudentType = 'error'
      this.todayAllotType = 'error'
      this.todayContactType = 'error'
      this.todayPublicType = 'error'
      this.myStudentType = 'error'
      this.godent = 'error'
      this.typeData = 'error'
      this.typeRanking = 'success'
      this.queryParam.newPublic = ''
      this.title = this.rankingTtile
      this.queryParam.type = ''
      this.queryParam.isPay = ''
      this.queryParam.isPrivate = 1
      if (this.listUrl === '/adminUser/crmRanking') {
        this.reload = new Date().getTime()
      } else {
        this.listUrl = '/adminUser/crmRanking'
      }
    },

    // 批量添加资源到公库
    onBatchMoveUser () {
      if (this.selectionUser.length <= 0) {
        this.$Message.warning('请选择需要批量添加到公库的学生！')
        return
      }
      this.showBatchMoveUser = true
    },

    // 添加学生
    onInsertUser () {
      this.showInsertUserModal = true
    },
    vault () {
      this.typeRanking = 'error'
      this.payStudentType = 'error'
      this.todayAllotType = 'error'
      this.todayContactType = 'error'
      this.todayPublicType = 'error'
      this.myStudentType = 'error'
      this.typeData = 'error'
      this.godent = 'success'
      this.queryParam.newPublic = ''
      this.title = this.privateTitle
      this.queryParam.type = ''
      this.queryParam.isPay = ''
      this.queryParam.isPrivate = 1
      if (this.listUrl === '/userList/crmList') {
        this.reload = new Date().getTime()
      } else {
        this.listUrl = '/userList/crmList'
      }
    },
    myStudent () {
      this.typeRanking = 'error'
      this.typeData = 'error'
      this.queryParam.isPay = 0
      this.payStudentType = 'error'
      this.todayAllotType = 'error'
      this.todayContactType = 'error'
      this.todayPublicType = 'error'
      this.godent = 'error'
      this.myStudentType = 'success'
      this.queryParam.newPublic = ''
      this.queryParam.type = -1
      this.queryParam.isPay = 0
      this.queryParam.isPrivate = 0
      this.title = this.resourceTitle
      if (this.listUrl === '/userList/crmList') {
        this.reload = new Date().getTime()
      } else {
        this.listUrl = '/userList/crmList'
      }
      delete this.queryParam.sortProperty
      delete this.queryParam.sortDirection
    },
    myStudentAll () {
      this.typeRanking = 'error'
      this.typeData = 'success'
      this.payStudentType = 'error'
      this.todayAllotType = 'error'
      this.todayContactType = 'error'
      this.todayPublicType = 'error'
      this.godent = 'error'
      this.myStudentType = 'error'
      this.queryParam.stdTab = ''
      this.queryParam.type = ''
      this.queryParam.isPay = ''
      this.title = this.resourceTitle
      if (this.listUrl === '/userList/crmList') {
        this.reload = new Date().getTime()
      } else {
        this.listUrl = '/userList/crmList'
      }
    },
    openInfoModal (val) {
      this.uid = val
      let {href} = this.$router.resolve({
        name: 'userPayDetail',
        query: {uid: val, tabName: 0, parm: self.queryParam, backPath: '/crm/MyResource'}
      })
      window.open(href, '_blank')
    },
    search () {
      let self = this
      let startTimeDate = dates.format(this.dateRange[0])
      let endTimeDate = dates.format(this.dateRange[1])
      self.queryParam.startTime = Date.parse(startTimeDate) / 1000
      self.queryParam.endTime = Date.parse(endTimeDate) / 1000
      this.reload = new Date().getTime()
      delete this.queryParam.adviserAssignTime
      delete this.queryParam.vaultTime
      delete this.queryParam.sortProperty
      delete this.queryParam.sortDirection
      this.selectionUser = []
    },
    searchCurr () {
      let self = this
      let startTimeDate = dates.format(this.dateRange[0])
      let endTimeDate = dates.format(this.dateRange[1])
      self.queryParam.startTime = Date.parse(startTimeDate) / 1000
      self.queryParam.endTime = Date.parse(endTimeDate) / 1000
      this.reload = 119
      this.selectionUser = []
    },
    todayAllot () {
      this.typeRanking = 'error'
      this.typeData = 'error'
      this.todayContactType = 'error'
      this.todayAllotType = 'success'
      this.todayPublicType = 'error'
      this.myStudentType = 'error'
      this.godent = 'error'
      this.queryParam.type = 1
      // this.queryParam.todayContact = ''
      this.queryParam.newPublic = 1
      this.title = this.resourceTitle
      delete this.queryParam.sortProperty
      delete this.queryParam.sortDirection
      if (this.listUrl === '/userList/todayAllot') {
        this.reload = new Date().getTime()
      } else {
        this.listUrl = '/userList/todayAllot'
      }
    },
    edit (uid) {
      this.uid = uid
      this.tabValue = 1
      this.editUser = true
    },
    closeModal (val) {
      this.tabValue = 0
      this.uid = null
      this.editUser = false
      // this.todayAllot()
    },
    todayOpenClass () {
      let self = this
      let query = {}
      query.startCreateTime = new Date(new Date().setHours(0, 0, 0, 0)).getTime() / 1000
      query.startCreateDate = self.$moment(query.startCreateTime, 'X').format('YYYY-MM-DD HH:mm')
      query.endCreateTime = new Date(new Date().setHours(0, 0, 0, 0)).getTime() / 1000 + 24 * 3600
      query.endCreateDate = self.$moment(query.endCreateTime, 'X').format('YYYY-MM-DD HH:mm')
      query.operatorIds = self.queryParam.adviserIds
      query.tchChannel = self.queryParam.tchChannel
      query.fromCrm = 1
      // query.lsnSelStatusList = [1, 2, 3]
      query.adviserId = self.queryParam.adviserId
      self.$router.push({path: '/lesson/bookLessonOpenedList', query: query})
    },
    todayLisent () {
      let self = this
      let query = {}
      query.startTime = new Date(new Date().setHours(0, 0, 0, 0)).getTime() / 1000
      query.startTimeDate = self.$moment(query.startTime, 'X').format('YYYY-MM-DD HH:mm')
      query.endTime = new Date(new Date().setHours(0, 0, 0, 0)).getTime() / 1000 + 24 * 3600
      query.endTimeDate = self.$moment(query.endTime, 'X').format('YYYY-MM-DD HH:mm')
      query.adviserIds = self.queryParam.adviserIds
      query.tchChannel = self.queryParam.tchChannel
      query.lsnType = 1
      // query.lsnSelStatusList = [1, 2, 3]
      query.adviserId = self.queryParam.adviserId
      self.$router.push({path: '/lesson/bookLessonOpenedList', query: query})
    },
    onPass (row) {
      let self = this
      self.$Modal.confirm({
        title: '温馨提示',
        content: '是否<span style="color: red">移除</span>此资源?',
        width: 300,
        okText: '确认',
        onOk: () => {
          self.$http.post('/userList/crmResourceUpdate', {id: row.uid}).then(function (res) {
            if (res) {
              self.searchCurr()
            }
          })
        }
      })
    },
    onMoveGent (row) {
      let self = this
      self.$Modal.confirm({
        title: '温馨提示',
        content: '是否<span style="color: red">移至</span>小金库?',
        width: 300,
        okText: '确认',
        onOk: () => {
          self.$http.post('/userList/updatePrivate', {id: row.uid, type: 1}).then(function (res) {
            if (res) {
              self.searchCurr()
            }
          })
        }
      })
    },
    onRemoveGent (row) {
      let self = this
      self.$Modal.confirm({
        title: '温馨提示',
        content: '是否<span style="color: red">移出</span>小金库?',
        width: 300,
        okText: '确认',
        onOk: () => {
          self.$http.post('/userList/updatePrivate', {id: row.uid, type: 0}).then(function (res) {
            if (res) {
              self.search()
            }
          })
        }
      })
    },
    onLoading (loading) {
      this.searchLoading = loading
    },
    onSelection (selection) {
      this.selection = selection
      this.queryParam.a = 99
    },
    selectionChange (selection) {
      this.selectionUser = selection
    },
    beginRegTimeChange (value) {
      this.queryParam.beginRegTime = value
    },
    endRegTimeChange (value) {
      this.queryParam.endRegTime = value
    },
    beginlastPhoneTime (value) {
      this.queryParam.beginlastPhoneTime = value
    },
    endlastPhoneTime (value) {
      this.queryParam.endlastPhoneTime = value
    },
    beginNextContactTime (value) {
      this.queryParam.beginNextContactTime = value
    },
    endNextContactTime (value) {
      this.queryParam.endNextContactTime = value
    },
    getAdviserInfo (obj) {
      if (obj) {
        this.queryParam.adviserId = obj.adviserId
        this.queryParam.teamType = obj.teamType
        this.queryParam.adviserIds = obj.adviserIds
        this.loadStatisticsData()
      }
    },
    onPunch () {
      let self = this
      self.$http.post('/adviser/onPunch').then(function (res) {
        if (res && res.data > 0) {
          self.$Message.success('打卡成功!')
          if (res.data > 250) {
            self.$Message.warning('目前未付费个人资源数为：' + res.data + '，超过300将不再自动分配资源')
          }
        } else {
          self.$Message.error('打卡失败!')
        }
      })
    },
    showPunchStatistics () {
      this.showTodayPunchStatisticsModal = true
    },

    onAssignAdviser () {
      if (this.selectionUser.length <= 0) {
        this.$Message.warning('请选择需分配课程顾问的学生！')
        return
      }
      this.showAssignAdviserModal = true
    },
    reloadAfterAssign () {
      this.selectionUser = []
      this.reload = new Date().getTime()
    },
    onAssignStudyAdviser () {
      if (this.selectionUser.length <= 0) {
        this.$Message.warning('请选择需分配学习顾问的学生！')
        return
      }
      this.showAssignUserStudyAdviserModal = true
    },
    onUnbingTch (row) {
      let self = this
      self.$Modal.confirm({
        title: '提示',
        content: '解绑之后，其他学生可以占用该绑定时间，是否确认解绑该老师？',
        width: 300,
        loading: true,
        onOk: () => {
          self.$http.post('/bookWordLessonOpenedTime/unbindTch', {uid: row.id}).then(function (res) {
            self.search()
            self.$Message.success('解绑成功!')
            self.$Modal.remove()
          })
        }
      })
    },
    onChangeDirector (row) {
      let self = this
      self.$Modal.confirm({
        title: '提示',
        content: '是否确认转移学员至学导部门经理？',
        width: 300,
        loading: true,
        onOk: () => {
          self.$http.post('/userTrack/changeDirectorRecord', {
            uid: row.id,
            nickname: row.nickname
          }).then(function (res) {
            self.search()
            self.$Message.success('转移成功!')
            self.$Modal.remove()
          })
        }
      })
    },
    dialTel (uid, mobile) {
      // 待增加,呼出电话功能
      if (!uid) {
        this.$Message.warning('学生ID不能为空')
        return
      }
//        if (!exten) {
//          this.$Message.warning('话机工号不能为空')
//          return
//        }
      if (!mobile) {
        this.$Message.warning('无效手机号码')
        return
      }
      this.dialLoading = true
      let self = this
      this.$http.get('/moor/call?callNo=' + mobile).then(function (res) {
        if (res.data > 0) {
          self.$Message.success('呼出成功!')
          self.dialLoading = false
        }
      })
//        this.$http.get('https://192.168.0.10:8443/api/call?team=hk&studentId=' + uid + '&exten=' + exten).then(function (res) {
//          if (res.code === 200) {
//            window.open('https://bops.kouyujie.cn/#/user/userPayDetail?uid=' + uid + '&tabName=4')
//             this.$Message.success('呼叫成功!')
//            this.dialLoading = false
//          } else {
//            this.$Message.errorMsg('呼叫失败!')
//          }
//        })
    },
    handleSortChange (column, key, order) {
      delete this.queryParam.sortProperty
      delete this.queryParam.sortDirection
      if (order && order !== 'normal') {
        let sortKeyMap = {}
        if (this.listUrl.indexOf('/userList/todayContact') !== -1) {
          if (key === 'nextContactTime') {
            sortKeyMap = { nextContactTime: 't.next_contact_time' }
          } else if (key === 'registerTime') {
            sortKeyMap = { registerTime: 'ul.gmt_create' }
          }
        } else if (this.listUrl.indexOf('/userList/crmList') !== -1) {
          if (key === 'nextContactTime') {
            sortKeyMap = { nextContactTime: 'nct.max_next_contact_time' }
          } else if (key === 'registerTime') {
            sortKeyMap = { registerTime: 'ul.gmt_create' }
          }
        } else if (this.listUrl.indexOf('/userList/todayAllot') !== -1) {
          if (key === 'nextContactTime') {
            sortKeyMap = { nextContactTime: 'nct.max_next_contact_time' }
          } else if (key === 'registerTime') {
            sortKeyMap = { registerTime: 'ul.gmt_create' }
          }
        }
        this.queryParam.sortProperty = sortKeyMap[key] || key
        this.queryParam.sortDirection = order
      }
      this.reload = new Date().getTime()
    },
    loadStatisticsData () {
      let self = this
      self.$http.get('/userList/targetStatistics?adviserIds=' + self.queryParam.adviserIds).then(function (res) {
        if (res.data) {
          self.orderQuantity = res.data.orderQuantity
          self.finishOrderQuantity = res.data.finishOrderQuantity
          self.dealMoney = res.data.dealMoney
          self.dealRate = res.data.dealRate
        }
      })
    }
  },
  mounted: function () {
    let query = this.$route.query
    if (query) {
      if (query.beginNextContactTime) {
        this.beginNextContact = query.beginNextContactTime
      }
      if (query.endNextContactTime) {
        this.endNextContact = query.endNextContactTime
      }
    }
  },
  created: function () {
    this.title = this.resourceTitle
    this.queryParam.newPublic = ''
    let query = this.$route.query
    if (query) {
      if (query.beginNextContactTime) {
        this.beginNextContact = query.beginNextContactTime
      }
      if (query.endNextContactTime) {
        this.endNextContact = query.endNextContactTime
      }
    }

    let week = new Date().getDay()
    let left = week
    if (week === 0) {
      left = 7
    }

    // let self = this
    // let now = Date.now()
    // this.dateRange[0] = dateFormat(new Date(now - (left + 6) * 24 * 60 * 60 * 1000), 'YYYY-MM-DD')
    // this.dateRange[1] = dateFormat(new Date(now - (left) * 24 * 60 * 60 * 1000), 'YYYY-MM-DD')
    // let startTimeDate = dates.format(this.dateRange[0])
    // let endTimeDate = dates.format(this.dateRange[1])
    // self.queryParam.startTime = Date.parse(startTimeDate) / 1000
    // self.queryParam.endTime = Date.parse(endTimeDate) / 1000
  }
}
</script>

<style scoped>
.margin {
  padding-left: 15px;
  margin-bottom: 20px;
}

.button-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.left-button {
  align-self: flex-start;
}

.right-button {
  align-self: flex-end;
}

.spacer {
  flex: 1;
}

.bg {
  background-color: red;
}

.flex {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}
</style>



// WEBPACK FOOTER //
// MyResource.vue?bd8843e2